import publicConfig from '@transfeeradev/public-config';
export default publicConfig[import.meta.env.MODE || 'development'];
